import { GET_METAL_TYPES_LOADING, GET_METAL_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getMetalTypesSuccess = payload => {
    return ({
        type: GET_METAL_TYPES_SUCCESS,
        payload
    })
}

export const getMetalTypesAsync = payload => dispatch => {
    return client.service('metal-types').find()
		.then((response) => {
            dispatch(getMetalTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}